module.exports = __webpack_public_path__ + "img/icon-ai-measure-line@2x.51b0a009.png";